import {createContext} from "react";
const InterfaceContext = createContext();
export default InterfaceContext;